module.exports = __webpack_public_path__ + "static/media/jacob.d580d1fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/jacob.jpg
// module id = 611
// module chunks = 0